import React from 'react';

const BannerBackground = ({ className }) => {
  return (
    <svg className={className} preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" width="790" height="534" viewBox="0 0 790 534" fill="none">
      <path opacity="0.5" d="M0 0H790L403.817 534H0V0Z" fill="#005299" />
    </svg>
  );
};

export default BannerBackground;
